<template>
  <b-form-group
    label="Misyonumuz"
    label-for="mission"
  >
    <validation-provider
      #default="{ errors }"
      name="Misyonumuz"
      rules="required"
    >
      <b-form-textarea
        id="mission"
        v-model="itemData.mission"
        placeholder="Misyonumuz"
        rows="10"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormTextarea } from 'bootstrap-vue'

export default {
  name: 'MissionContent',
  components: {
    BFormGroup,
    BFormTextarea,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['about/dataItem']
    },
  },
}
</script>
